import { useFeatureFlagRule } from "@/hooks/shared/useFeatureFlag";
import { useCurrentUser } from "@/app/auth/CurrentUserContext";

/**
 * Whether the signed-in user may access network bandwidth diagnostics.
 *
 * Backs the ROUTE guard, so it reads the flag's own rule and ignores demo mode
 * — demo mode must not evict a page the user is already on (see
 * `useFeatureFlagRule`). The Diagnostics nav entry is hidden separately, via
 * the suppressed `useFeatureFlag` in `AuthenticatedLayoutChrome`.
 */
export const useBandwidthDiagnosticsAccess = (): {
  canAccess: boolean;
  isLoading: boolean;
  flagEnabled: boolean;
  isIctProfessional: boolean;
} => {
  const flagEnabled = useFeatureFlagRule("bandwidthDiagnostics");
  const { isIctProfessional, isLoading, isRolesResolved } = useCurrentUser();
  const accessPending = isLoading || !isRolesResolved;

  return {
    canAccess: !accessPending && flagEnabled && isIctProfessional,
    isLoading: accessPending,
    flagEnabled,
    isIctProfessional,
  };
};
